<template>
  <div>
    <SchemaFieldRelationSelector :value="localValue" @update="updateRelation" multiple />
    <v-text-field
      label="Min Count"
      type="number"
      min="0"
      v-model.number="localValue.min_count"
      hide-details
    ></v-text-field>
    <v-text-field
      label="Max Count"
      type="number"
      min="0"
      v-model.number="localValue.max_count"
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      localValue: {
        ...this.value,
        min_count: this.value.min_count ?? null,
        max_count: this.value.max_count ?? null,
      },
    };
  },
  methods: {
    updateRelation($event) {
      this.localValue = { ...this.localValue, ...$event };
    },
  },
  watch: {
    localValue: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit("update", { ...this.localValue });
      },
    },
  },
};
</script>

<style></style>
